<template>
  <exportTemplate :formModel="formModel" :table-data="tableList" :summary-data="tableSummaryData" :table-total="paginationTotal" :table-load="tableLoading" :show-custom-columns="false" @pagination-change="paginationChange" @form-submit="formSubmit" @form-reset="formReset" @sort="sortChange" @table-export="tableExport" @emitDblclick="emitDblclick">
    <template #form>
      <el-form-item label="日期范围" prop="billDate.selected">
        <date-picker style="width: 100%;" v-model="formModel.billDate.selected" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></date-picker>
      </el-form-item>
      <el-form-item label="操作人" prop="salesman.selected">
        <select-multiple :select-data="formModel.salesman"></select-multiple>
      </el-form-item>
      <el-form-item label="款项类型" prop="payType.selected">
        <el-select class="select_multiple" style="width: 100%;" v-model="formModel.payType.selected" clearable placeholder="请选择款项类型">
          <el-option v-for="item in formModel.payType.list" :key="item.value" :label="item.text" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="isRedStrick.selected" style="text-align: center;">
        <el-checkbox v-model="formModel.isRedStrick.selected" true-label="Y" false-label="N">显示红冲单据</el-checkbox>
      </el-form-item>
    </template>
    <template>
      <el-table-column label="日期时间" prop="billDate" width="150"></el-table-column>
      <el-table-column label="单据类型" prop="billTypeFormat" width="100"></el-table-column>
      <el-table-column label="单号" prop="billNo" width="168"></el-table-column>
      <el-table-column label="客户" prop="customerName" width="150"></el-table-column>
      <el-table-column label="款项类型" prop="payType" width="100"></el-table-column>
      <el-table-column label="应付金额" prop="arrearAmt" width="100"></el-table-column>
      <el-table-column label="应付余额" prop="arrearBanalce" width="100"></el-table-column>
      <el-table-column label="预付金额" prop="prePayAmt" width="100"></el-table-column>
      <el-table-column label="预付余额" prop="prePayBanalce" width="100"></el-table-column>
      <el-table-column label="操作人" prop="salesmanName" width="150"></el-table-column>
    </template>
  </exportTemplate>
</template>

<script>
import exportTemplate from '@/components/common/exportTemplate.vue'
import datePicker from '@/components/common/datePicker.vue'
import { pickerOptions, getNowFormatDate, getAddDate, getQueryItem, exportExcelCommonForVue } from '@/assets/js/common.js'
export default {
  name: 'mainAccount',
  components: {
    exportTemplate,
    datePicker
  },
  props: ['options'],
  data() {
    return {
      pickerOptions,
      params: {
        page: 1,
        size: 10,
        customerID: '',
        isRedStrick: 'N',
        beginDate: getAddDate(-3),
        endDate: getNowFormatDate()
      },
      formModel: {
        billDate: { submitName: 'billDate', selected: [getAddDate(-3), getNowFormatDate()] },
        salesman: { submitName: 'salesmanID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择操作人', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5, isFitterEnabled: 'N' }, text: '', value: '' } },
        isRedStrick: { submitName: 'isRedStrick', selected: 'N' },
        customer: { submitName: 'customerID', selected: [], list: [] },
        payType: { submitName: 'payType', selected: '', list: [{ text: '预付', value: 'B' }, { text: '应付', value: 'C' }, { text: '预付+应付', value: 'D' }] },
      },
      paginationTotal: 0,
      tableList: [],
      tableLoading: false,
      tableSummaryData: {}
    }
  },
  created() {
    let { billDate, customer } = this.options
    if (billDate) {
      this.formModel.billDate.selected = billDate
    }
    if (customer) {
      this.formModel.customer.selected = customer.value
      this.formModel.customer.list = [customer]
    }
    this.params = { ...this.params, ...getQueryItem(this.formModel) }
    this.getTableList()
  },
  methods: {
    paginationChange({page, size, isGetTable = true}) {
      this.params.page = page
      this.params.size = size
      if (isGetTable) {
        this.getTableList()
      }
    },
    formSubmit() {
      this.params = { ...this.params, ...getQueryItem(this.formModel) }
      this.getTableList()
    },
    formReset() {
      this.params['sortField'] = ''
      this.params['softBy'] = ''
      this.params.page = 1
    },
    async getTableList() {
      // this.tableList = [{ billType: 1,billNo:2  }]
      this.tableLoading = true
      this.tableData = []
      const { data: res } = await this.$post(
        "/erpnew/account/c/reada46ceb/purPayBalanceController/selectPurPayDetails.html",
        this.params
      )
      this.tableLoading = false
      if (res.code != '0') return this.$message.error(res.message)
      let { data, sum, total } = res.data
      this.paginationTotal = total
      this.tableSummaryData = sum
      this.tableList = data
    },
    sortChange({ sortField, sortBy }) {
      this.params['sortField'] = sortField
      this.params['sortBy'] = sortBy
      this.params.page = 1
      this.getTableList()
    },
    tableExport(tabColumn) {
      exportExcelCommonForVue(this.params, tabColumn, '/erpnew/account/c/reada46ceb/purPayBalanceController/selectPurPayDetailsExport.html')
      console.log(tabColumn)
    },
    emitDblclick(row) {
      console.log(row.billType,row.billNo)
      if(row.billType === 'HCD') {
        row.billType = row.billNo.replace(/[^a-zA-Z]/g,"")
      }
      if(!row.billType || row.billType === 'FKD' || row.billType === 'TZD' || row.billType === 'QC') {
        console.log("不跳")
        this.$message({ message: '暂无数据', type: 'warning'})
        return
      }

      console.log(row.billType,row.billNo)
      let width = window.top.document.browser.availiframeWidth.value
      let height = window.top.document.browser.availiframeHeight.value
      if(row.billType == 'CG') {
          top.addPanel('采购订单详情', `/yunsierp3/index.html#/enterPage/purchaseOrderEntry?billNo=${ row.billNo }&billType=${row.billType}`, width, height, true)
      } else if(row.billType == 'TG') {
        top.addPanel('采购退货详情', `/yunsierp3/index.html#/enterPage/purchaseReturnEntry?billNo=${ row.billNo }&billType=${row.billType}`, width, height, true)
      } else {
        top.addPanel('单据详情', `/yunsierp3/index.html#/docket/docketDetails?billType=${ row.billType }&billNo=${ row.billNo }`, width, height, true)
      }
    }
  }
}
</script>

<style lang="less" scoped>
</style>